document.addEventListener('DOMContentLoaded', () => {
  const collectionProducts = document.querySelectorAll('.bundle-collection-product');
  const productsAddBtns = document.querySelectorAll('.bundle-collection-product-add');
  const sideCart = document.querySelector('.bundle-collection-side-cart');
  const sideCartMob = document.querySelector('.bundle-collection-side-cart-mob');
  const checkoutBtn = document.querySelector('.bundle-collection-side-cart-checkout');
  const checkoutBtnMob = document.querySelector(
    '.bundle-collection-side-cart-mob .bundle-collection-side-cart-checkout'
  );
  const mobileSideCart = document.querySelector('.bundle-collection-side-cart.bundle-collection-side-cart-mob');
  const mobSideCartTriggerBtn = document.querySelector('.bundle-collection-side-cart-mob-trigger');
  const filterButtons = document.querySelectorAll('.bundle-collection-filter');
  const detailsPopTriggerBtns = document.querySelectorAll('.bundle-collection-product-details-trigger');

  const quantityButtons = document.querySelectorAll(
    '.bundle-collection-product-quantity-minus, .bundle-collection-product-quantity-plus'
  );

  const stickyProgress = document.querySelector('.bundle-collection-progress-wrapper-mob-sticky');
  const defaultProgress = document.querySelector('.bundle-collection-progress-wrapper-mob-def');

  mobSideCartTriggerBtn.addEventListener('click', () => {
    mobileSideCart.classList.toggle('active');
  });

  if (stickyProgress && defaultProgress) {
    stickyProgress.style.opacity = '0';
    stickyProgress.style.transition = 'opacity 0.3s ease';

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            stickyProgress.style.opacity = '0';
          } else {
            stickyProgress.style.opacity = '1';
          }
        });
      },
      {
        threshold: 0,
        rootMargin: '0px',
      }
    );

    observer.observe(defaultProgress);
  }

  detailsPopTriggerBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const product = btn.closest('.bundle-collection-product');
      const details = document.querySelector(
        `.bundle-collection-product-details[data-product-id="${product.dataset.productId}"]`
      );
      details.classList.add('active');

      const closeBtn = details.querySelector('.bundle-collection-product-details-close-btn');
      const closeSvg = details.querySelector('.bundle-collection-product-close-svg');

      closeSvg.addEventListener('click', () => {
        details.classList.remove('active');
      });

      closeBtn.addEventListener('click', () => {
        details.classList.remove('active');
      });
    });
  });

  filterButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      // Remove selected from all
      filterButtons.forEach((b) => b.classList.remove('selected'));
      btn.classList.add('selected');

      const handle = btn.dataset.filterCollectionHandle;

      collectionProducts.forEach((product) => {
        const productCollections = product.dataset.productCollections
          ? product.dataset.productCollections.split(',')
          : [];
        if (handle === 'all' || productCollections.includes(handle)) {
          product.style.display = '';
        } else {
          product.style.display = 'none';
        }
      });
    });
  });

  quantityButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      const quantityContainer = event.target.closest('.bundle-collection-product-quantity');
      const product = quantityContainer.closest('.bundle-collection-product');
      const input = quantityContainer.querySelector('.bundle-collection-product-quantity-input');
      const action = event.target.getAttribute('data-action');
      const min = parseInt(input.getAttribute('min'));
      const max = parseInt(input.getAttribute('max'));
      let currentValue = parseInt(input.value);

      if (action === 'decrease' && currentValue > min) {
        input.value = currentValue - 1;
        const selectedItems = document.querySelectorAll(
          `.bundle-collection-side-cart-item[data-item-variant-id="${product.dataset.productVariantId}"]`
        );
        selectedItems.forEach((selectedItem) => {
          const itemCount = parseInt(selectedItem.getAttribute('data-item-count'), 10);
          selectedItem.setAttribute('data-item-count', itemCount - 1);
          selectedItem.querySelector('.bundle-collection-side-cart-item-count').textContent = itemCount - 1;
        });

        updateSideCartData();
      } else if (action === 'increase' && currentValue < max) {
        const sideCartItems = document.querySelectorAll(
          '.bundle-collection-side-cart.bundle-collection-side-cart-mob .bundle-collection-side-cart-item'
        );
        let sideCartCurrentCount = 0;

        sideCartItems.forEach((item) => {
          sideCartCurrentCount += parseInt(item.getAttribute('data-item-count'), 10);
        });

        if (sideCartCurrentCount >= sideCart.dataset.maxItemsCount) {
          return;
        }

        input.value = currentValue + 1;
        const selectedItems = document.querySelectorAll(
          `.bundle-collection-side-cart-item[data-item-variant-id="${product.dataset.productVariantId}"]`
        );
        selectedItems.forEach((selectedItem) => {
          const itemCount = parseInt(selectedItem.getAttribute('data-item-count'), 10);
          selectedItem.setAttribute('data-item-count', itemCount + 1);
          selectedItem.querySelector('.bundle-collection-side-cart-item-count').textContent = itemCount + 1;
        });

        updateSideCartData();
      }
    });
  });

  // Handle both desktop and mobile checkout buttons
  [checkoutBtn, checkoutBtnMob].forEach((btn) => {
    if (btn) {
      btn.addEventListener('click', async () => {
        const sideCartItems = document.querySelectorAll('.bundle-collection-side-cart.bundle-collection-side-cart-mob .bundle-collection-side-cart-item');

        if (sideCartItems.length === 0) {
          return;
        }

        // Disable both buttons to prevent multiple clicks
        if (checkoutBtn) {
          checkoutBtn.disabled = true;
          checkoutBtn.textContent = 'Bezig...';
        }
        if (checkoutBtnMob) {
          checkoutBtnMob.disabled = true;
          checkoutBtnMob.textContent = 'Bezig...';
        }

        try {
          // Prepare items for cart
          const items = [];
          sideCartItems.forEach((item) => {
            items.push({
              id: parseInt(item.getAttribute('data-item-variant-id')),
              quantity: parseInt(item.getAttribute('data-item-count')),
              properties: {
                '_bundelKorting': true,
              }
            });
          });

          // Add items to Shopify cart
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ items: items }),
          });

          if (response.ok) {
            // Redirect to checkout
            window.location.href = '/checkout';
          } else {
            throw new Error('Failed to add items to cart');
          }
        } catch (error) {
          console.error('Error adding items to cart:', error);
          // Re-enable buttons
          if (checkoutBtn) {
            checkoutBtn.disabled = false;
            checkoutBtn.textContent = 'Afrekenen';
          }
          if (checkoutBtnMob) {
            checkoutBtnMob.disabled = false;
            checkoutBtnMob.textContent = 'Afrekenen';
          }
        }
      });
    }
  });

  productsAddBtns.forEach((btn) => {
    btn.addEventListener('click', (event) => {
      const sideCartItems = document.querySelectorAll(
        '.bundle-collection-side-cart.bundle-collection-side-cart-mob .bundle-collection-side-cart-item'
      );
      let sideCartCurrentCount = 0;

      sideCartItems.forEach((item) => {
        sideCartCurrentCount += parseInt(item.getAttribute('data-item-count'), 10);
      });
      console.log('MAX ITEMS', sideCartCurrentCount);
      if (sideCartCurrentCount >= sideCart.dataset.maxItemsCount) {
        return;
      }

      const product = event.currentTarget.closest('.bundle-collection-product');

      if (product.classList.contains('added')) {
        const selectedItems = document.querySelectorAll(
          `.bundle-collection-side-cart-item[data-item-variant-id="${product.dataset.productVariantId}"]`
        );
        selectedItems.forEach((selectedItem) => {
          const itemCount = parseInt(selectedItem.getAttribute('data-item-count'), 10);
          selectedItem.setAttribute('data-item-count', itemCount + 1);
          selectedItem.querySelector('.bundle-collection-side-cart-item-count').textContent = itemCount + 1;
        });

        updateSideCartData();
      } else {
        addCartItem(product);
      }
    });
  });

  function addCartItem(product) {
    const sideCartContent = document.querySelector('.bundle-collection-side-cart-content');
    const sideCartContentMob = document.querySelector(
      '.bundle-collection-side-cart-mob .bundle-collection-side-cart-content'
    );

    product.classList.add('added');

    const cartItemHTML = `
      <div class="bundle-collection-side-cart-item-count">1</div>
      <img src="${product.dataset.productImage}" alt="${product.dataset.productTitle}" />
      <div class="bundle-collection-side-cart-item-info">
        <span>${product.dataset.productTitle}</span>
      </div>
      <div class="bundle-collection-side-cart-item-remove">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M3.21694 10.1433C3.05464 10.3056 3.05464 10.5688 3.21694 10.7311C3.37923 10.8934 3.64237 10.8934 3.80466 10.7311L6.974 7.56173L10.1433 10.7311C10.3056 10.8934 10.5688 10.8934 10.7311 10.7311C10.8934 10.5688 10.8934 10.3056 10.7311 10.1433L7.56173 6.974L10.7311 3.80466C10.8934 3.64237 10.8934 3.37923 10.7311 3.21694C10.5688 3.05464 10.3056 3.05464 10.1433 3.21694L6.974 6.38628L3.80466 3.21694C3.64237 3.05464 3.37923 3.05464 3.21694 3.21694C3.05464 3.37923 3.05464 3.64237 3.21694 3.80466L6.38628 6.974L3.21694 10.1433Z" fill="#262729"/>
        </svg>
      </div>
    `;

    // Create cart item for desktop
    const cartItem = document.createElement('div');
    cartItem.classList.add('bundle-collection-side-cart-item');
    cartItem.setAttribute('data-item-variant-id', product.dataset.productVariantId);
    cartItem.setAttribute('data-item-variant-price', product.dataset.productVariantPrice);
    cartItem.setAttribute('data-item-count', 1);
    cartItem.innerHTML = cartItemHTML;
    sideCartContent.appendChild(cartItem);

    // Create cart item for mobile
    if (sideCartContentMob) {
      const cartItemMob = document.createElement('div');
      cartItemMob.classList.add('bundle-collection-side-cart-item');
      cartItemMob.setAttribute('data-item-variant-id', product.dataset.productVariantId);
      cartItemMob.setAttribute('data-item-variant-price', product.dataset.productVariantPrice);
      cartItemMob.setAttribute('data-item-count', 1);
      cartItemMob.innerHTML = cartItemHTML;
      sideCartContentMob.appendChild(cartItemMob);
    }

    removeCartItem();
    updateSideCartData();
  }

  function removeCartItem() {
    const sideCartItemsUpdated = document.querySelectorAll('.bundle-collection-side-cart-item');

    sideCartItemsUpdated.forEach((item) => {
      const removeBtn = item.querySelector('.bundle-collection-side-cart-item-remove');
      if (removeBtn && !removeBtn.hasAttribute('data-listener-added')) {
        removeBtn.setAttribute('data-listener-added', 'true');
        removeBtn.addEventListener('click', () => {
          const variantId = item.dataset.itemVariantId;

          // Remove from both desktop and mobile
          const allItemsWithVariant = document.querySelectorAll(
            `.bundle-collection-side-cart-item[data-item-variant-id="${variantId}"]`
          );
          allItemsWithVariant.forEach((itemElement) => {
            itemElement.remove();
          });

          // Update product state
          collectionProducts.forEach((product) => {
            if (product.dataset.productVariantId === variantId) {
              product.classList.remove('added');
              // Reset quantity input to 1
              const quantityInput = product.querySelector('.bundle-collection-product-quantity-input');
              if (quantityInput) {
                quantityInput.value = 1;
              }
            }
          });

          updateSideCartData();
        });
      }
    });
  }

  function updateSideCartData() {
    const sideCartEl = document.querySelector('.bundle-collection-side-cart');
    const sideCartElMob = document.querySelector('.bundle-collection-side-cart-mob');
    const sideCartProducts = document.querySelectorAll(
      '.bundle-collection-side-cart:not(.bundle-collection-side-cart-mob) .bundle-collection-side-cart-item'
    );

    // Get all elements that need to be updated for both desktop and mobile
    const elementsToUpdate = {
      subtotalCount: document.querySelectorAll('.bundle-collection-side-cart-subtotal-label-count'),
      discountEl: document.querySelectorAll('.bundle-collection-side-cart-discount'),
      cartSubtotalEl: document.querySelectorAll('.bundle-collection-side-cart-subtotal-value'),
      cartTotalEl: document.querySelectorAll('.bundle-collection-side-cart-total-value'),
      cartDiscountEl: document.querySelectorAll('.bundle-collection-side-cart-discount-value-price'),
      cartDiscountElValue: document.querySelectorAll('.bundle-collection-side-cart-discount-value'),
      checkoutBtns: document.querySelectorAll('.bundle-collection-side-cart-checkout'),
    };

    let sideCartCurrentCount = 0;
    let totalPrice = 0;
    let totalDiscount = 0;
    const itemsCount = document.querySelector('.bundle-collection-side-cart-count-current');
    const progressBlock = document.querySelector('.bundle-collection-progress-wrapper[data-main]');
    const progressBlockMob = document.querySelector(
      '.bundle-collection-progress-wrapper.bundle-collection-progress-wrapper-mob-sticky'
    );
    const progressBlockMobDef = document.querySelector(
      '.bundle-collection-progress-wrapper.bundle-collection-progress-wrapper-mob-def'
    );

    sideCartProducts.forEach((item) => {
      sideCartCurrentCount += parseInt(item.getAttribute('data-item-count'), 10);
      totalPrice +=
        parseFloat(item.getAttribute('data-item-variant-price')) * parseInt(item.getAttribute('data-item-count'), 10);
    });

    if (itemsCount) itemsCount.textContent = sideCartCurrentCount;
    elementsToUpdate.subtotalCount.forEach((el) => {
      if (el) el.textContent = sideCartCurrentCount;
    });

    // Progress logic
    if (sideCartCurrentCount === +progressBlock.dataset.stepFour) {
      [progressBlock, progressBlockMob, progressBlockMobDef].forEach((block) => {
        if (block) {
          block.classList.add('completed');
          block.classList.remove('in-progress-step-3', 'in-progress-step-2', 'in-progress-step-1');
        }
      });

      elementsToUpdate.cartDiscountElValue.forEach((el) => {
        if (el) el.innerText = progressBlock.dataset.stepFourDiscount + '%';
      });
      totalDiscount = totalPrice * (progressBlock.dataset.stepFourDiscount / 100);
      const discountText =
        '-' +
        sideCartEl.getAttribute('data-cart-currency-symbol') +
        ((totalPrice * (progressBlock.dataset.stepFourDiscount / 100)) / 100).toFixed(2).replace('.', ',');
      elementsToUpdate.cartDiscountEl.forEach((el) => {
        if (el) el.innerText = discountText;
      });
    } else if (sideCartCurrentCount >= +progressBlock.dataset.stepThree) {
      [progressBlock, progressBlockMob, progressBlockMobDef].forEach((block) => {
        if (block) {
          block.classList.add('in-progress-step-3');
          block.classList.remove('completed', 'in-progress-step-2', 'in-progress-step-1');
        }
      });

      elementsToUpdate.cartDiscountElValue.forEach((el) => {
        if (el) el.innerText = progressBlock.dataset.stepThreeDiscount + '%';
      });
      totalDiscount = totalPrice * (progressBlock.dataset.stepThreeDiscount / 100);
      const discountText =
        '-' +
        sideCartEl.getAttribute('data-cart-currency-symbol') +
        ((totalPrice * (progressBlock.dataset.stepThreeDiscount / 100)) / 100).toFixed(2).replace('.', ',');
      elementsToUpdate.cartDiscountEl.forEach((el) => {
        if (el) el.innerText = discountText;
      });
    } else if (sideCartCurrentCount >= +progressBlock.dataset.stepTwo) {
      [progressBlock, progressBlockMob, progressBlockMobDef].forEach((block) => {
        if (block) {
          block.classList.add('in-progress-step-2');
          block.classList.remove('completed', 'in-progress-step-3', 'in-progress-step-1');
        }
      });

      elementsToUpdate.cartDiscountElValue.forEach((el) => {
        if (el) el.innerText = progressBlock.dataset.stepTwoDiscount + '%';
      });
      totalDiscount = totalPrice * (progressBlock.dataset.stepTwoDiscount / 100);
      const discountText =
        '-' +
        sideCartEl.getAttribute('data-cart-currency-symbol') +
        ((totalPrice * (progressBlock.dataset.stepTwoDiscount / 100)) / 100).toFixed(2).replace('.', ',');
      elementsToUpdate.cartDiscountEl.forEach((el) => {
        if (el) el.innerText = discountText;
      });
    } else if (sideCartCurrentCount >= +progressBlock.dataset.stepOne) {
      [progressBlock, progressBlockMob, progressBlockMobDef].forEach((block) => {
        if (block) {
          block.classList.add('in-progress-step-1');
          block.classList.remove('completed', 'in-progress-step-3', 'in-progress-step-2');
        }
      });

      elementsToUpdate.cartDiscountElValue.forEach((el) => {
        if (el) el.innerText = progressBlock.dataset.stepOneDiscount + '%';
      });
      totalDiscount = totalPrice * (progressBlock.dataset.stepOneDiscount / 100);
      const discountText =
        '-' +
        sideCartEl.getAttribute('data-cart-currency-symbol') +
        ((totalPrice * (progressBlock.dataset.stepOneDiscount / 100)) / 100).toFixed(2).replace('.', ',');
      elementsToUpdate.cartDiscountEl.forEach((el) => {
        if (el) el.innerText = discountText;
      });
    } else {
      [progressBlock, progressBlockMob, progressBlockMobDef].forEach((block) => {
        if (block) {
          block.classList.remove('in-progress-step-1', 'in-progress-step-2', 'in-progress-step-3', 'completed');
        }
      });

      elementsToUpdate.cartDiscountElValue.forEach((el) => {
        if (el) el.innerText = '0%';
      });
      totalDiscount = 0;
      const discountText = '-' + sideCartEl.getAttribute('data-cart-currency-symbol') + '0,00';
      elementsToUpdate.cartDiscountEl.forEach((el) => {
        if (el) el.innerText = discountText;
      });
    }

    const cartSubtotalValue = ((totalPrice - totalDiscount) / 100).toFixed(2).replace('.', ',');
    totalPrice = (totalPrice / 100).toFixed(2).replace('.', ',');

    const totalText = sideCartEl.getAttribute('data-cart-currency-symbol') + cartSubtotalValue;
    const subtotalText = sideCartEl.getAttribute('data-cart-currency-symbol') + totalPrice;

    elementsToUpdate.cartTotalEl.forEach((el) => {
      if (el) el.textContent = totalText;
    });
    elementsToUpdate.cartSubtotalEl.forEach((el) => {
      if (el) el.textContent = subtotalText;
    });

    // Show/hide discount section
    elementsToUpdate.discountEl.forEach((el) => {
      if (el) {
        el.style.display = sideCartCurrentCount >= +progressBlock.dataset.stepOne ? 'flex' : 'none';
      }
    });

    // Update checkout button state
    elementsToUpdate.checkoutBtns.forEach((btn) => {
      if (btn) {
        if (sideCartCurrentCount > 0) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      }
    });
  }
});